import raf from "raf"
import domready from "domready"
// noinspection ES6UnusedImports
import STYLE from "./style.css"
import {
    CubeCamera,
    DirectionalLight,
    PerspectiveCamera,
    Scene,
    Sprite,
    SpriteMaterial,
    sRGBEncoding,
    WebGLRenderer,
    WebGLCubeRenderTarget, Color, Vector3, Euler
} from "three"

import { Sky } from "three/examples/jsm/objects/Sky.js";

import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import loadTexture from "./loadTexture";

const SKY_EFFECT = true;

let container, stats, envMap;
let camera, scene, renderer, light;
let controls;


const skyParameters = {
    distance: 1000,
    inclination: 0.42,
    azimuth: 0.1
};


function updateSun()
{

    if (!sky)
    {
        return;
    }

    const theta = Math.PI * (skyParameters.inclination - 0.5);
    const phi = 2 * Math.PI * (skyParameters.azimuth - 0.5);

    light.position.x = skyParameters.distance * Math.cos(phi);
    light.position.y = skyParameters.distance * Math.sin(phi) * Math.sin(theta);
    light.position.z = skyParameters.distance * Math.sin(phi) * Math.cos(theta);

    sky.material.uniforms["sunPosition"].value = light.position.copy(light.position);

    cubeCamera.update(renderer, sky);

}


let cubeCamera, sky;



const CAMERA_MATRIX = [0.9998967436652689,1.0842021724855044e-19,-0.014370177716070404,0,0.0017518645549679747,0.9925411913624905,0.12189714688748401,0,0.014262993310399232,-0.12190973483987161,0.9924387051970008,0,1.5116542598268052,-12.939086754479849,105.26297989017192,1];


function init()
{

    container = document.getElementById("container");

    //

    renderer = new WebGLRenderer();
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.outputEncoding = sRGBEncoding
    container.appendChild(renderer.domElement);

    //

    scene = new Scene();

    camera = new PerspectiveCamera(55, window.innerWidth / window.innerHeight, 1, 20000);

    //camera.position.set(25, 25, 100);

    camera.matrix.fromArray(CAMERA_MATRIX);
    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);

    //

    light = new DirectionalLight("#fff8d5", 0.8);
    scene.add(light);



    cubeCamera = new CubeCamera(0.2, 1, new WebGLCubeRenderTarget(512));
    // cubeCamera.renderTarget.texture.generateMipmaps = true;
    // cubeCamera.renderTarget.texture.minFilter = LinearMipmapLinearFilter;

    scene.background = cubeCamera.renderTarget;

    // Skybox
    if (SKY_EFFECT)
    {
        sky = new Sky();


        // uniforms["turbidity"].value = 5;
        // uniforms["rayleigh"].value = 1.2;
        // uniforms["luminance"].value = 1;
        // uniforms["mieCoefficient"].value = 0.05;
        // uniforms["mieDirectionalG"].value = 0.9;

        envMap = cubeCamera.renderTarget.texture

        updateSun();
    }
    else
    {
        envMap = null;
    }

    if (ORBIT_CONTROLS)
    {
        controls = new OrbitControls(camera, renderer.domElement);
        //controls.maxPolarAngle = Math.PI * 0.45;
        controls.maxPolarAngle = Math.PI;
        controls.target.set(0, 0, 0);
        controls.minDistance = 0.0;
        controls.maxDistance = 150.0;
        controls.enableDamping = true;
        controls.dampingFactor = 0.02;
        controls.update();

    }


    console.log("CAMERA", JSON.stringify(camera.matrix.toArray()));

    // stats = new Stats();
    // container.appendChild( stats.dom );

    // GUI

    //const gui = new GUI();

    // const folder = gui.addFolder( "Sky" );
    // folder.add( skyParameters, "inclination", 0, 0.5, 0.0001 ).onChange( updateSun );
    // folder.add( skyParameters, "azimuth", 0, 1, 0.0001 ).onChange( updateSun );
    // folder.open();
    //
    // const uniforms = water.material.uniforms;
    //
    // const folder = gui.addFolder( "Water" );
    // folder.add( uniforms.distortionScale, "value", 0, 8, 0.1 ).name( "distortionScale" );
    // folder.add( uniforms.size, "value", 0.1, 10, 0.1 ).name( "size" );
    // folder.add( uniforms.alpha, "value", 0.9, 1, .001 ).name( "alpha" );
    // folder.open();

    window.addEventListener("resize", onWindowResize, false);
    window.addEventListener("dblclick", ev =>{

        console.log("CAMERA", JSON.stringify(camera.matrix.toArray()))

    }, false);

}


function onWindowResize()
{

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(window.innerWidth, window.innerHeight);

}


let inclinationCount = 0;


function mainLoop()
{

    render();
    //stats.update();

    //skyParameters.inclination = -0.012 + Math.sin(inclinationCount += 0.01) * 0.524;

    updateSun();

    if (controls)
    {
        controls.update()
    }
    raf(mainLoop);

}

function render()
{
    renderer.render(scene, camera);
}

const NUM_SPHERES = 110;

const ORBIT_CONTROLS = true;

// scale of each sphere
const SPHERE_SCALE = 12;

// size of the random sphere spawn area
const SPHERE_AREA = 120;

const TAU = 2 * Math.PI;
const PHI = (1+Math.sqrt(5))/2;

function addSprite(mat, x, y, z)
{
    const sprite = new Sprite(mat);
    scene.add(sprite);

    sprite.position.set(
        x,
        y,
        z
    );
    sprite.scale.set(SPHERE_SCALE, SPHERE_SCALE, SPHERE_SCALE);

}

const DISTANCE = SPHERE_SCALE * 1.14589803375031543

const tmp = new Vector3();
const tmpY = new Vector3();

domready(() => {

    Promise.all([
        loadTexture("assets/transparent-dot.png")
    ])
    .then(([ tDot ]) =>
    {

        const mat = [];

        for (let i=0; i < 256; i++)
        {
            const color = new Color(0,0,0);
            const color2 = new Color(0,0,0);

            const hue = i * PHI;
            color.setHSL(hue, 0.8, 0.57);
            color2.setHSL(hue, 1, 0.2);

            mat[i] = new SpriteMaterial({
                map: tDot,
                color: color2,//: i&1? color:  color2,
                transparent: true,
            });

        }



        init();

        const half = SPHERE_AREA/2;

        const max = Math.sqrt(half*half * 3);





        const xVector = new Vector3(1, 0, 0);
        const yVector = new Vector3(0, 1, 0);
        const zVector = new Vector3(0, 0, -1);
        xVector.applyEuler(camera.rotation);
        yVector.applyEuler(camera.rotation);
        zVector.applyEuler(camera.rotation);

        console.log("EYE VECTOR: ", {xVector,yVector,zVector});


        addSprite(mat[0], 0, 0, 0);

        let radius = DISTANCE;
        for (let i=0; i < 50; i++)
        {

            const spheres = Math.floor(TAU * radius / DISTANCE);
            const step = TAU / spheres;

            for (let j=0; j < spheres; j++)
            {
                tmp.copy(xVector).multiplyScalar(Math.cos(j * step) * radius);
                tmpY.copy(yVector).multiplyScalar(Math.sin(j * step) * radius);

                tmp.add(tmpY);

                addSprite(mat[i + 1], tmp.x, tmp.y, tmp.z);
            }

            radius += DISTANCE;
        }



        // for (let i=0; i < NUM_SPHERES; i++)
        // {
        //     for (let j = 0; j < tDot.length; j++)
        //     {
        //         const tDotElement = tDot[j];
        //
        //     }
        //
        //     const x = Math.random() * SPHERE_AREA - half;
        //     const y = Math.random() * SPHERE_AREA - half;
        //     const z = Math.random() * SPHERE_AREA - half;
        //
        //     const d =Math.sqrt(x * x + y * y + z * z)/max;
        //     const sprite = new Sprite(mat[ d*16|0]);
        //     scene.add(sprite);
        //
        //     sprite.position.set(
        //         x,
        //         y,
        //         z
        //     );
        //     sprite.scale.set(SPHERE_SCALE, SPHERE_SCALE, SPHERE_SCALE);
        // }

        mainLoop();

    })

})

